import styles from './styles.module.scss';

export const GlobalHeader = () => {
  return (
    <div className={styles.Header}>
      <div className={styles.Header__Title}>加盟店管理画面</div>
    </div>
  );
};
